import { FC, ReactNode, ChangeEvent } from 'react';
import { graphql, useFragment } from 'react-relay';
import { defineMessages, useIntl } from 'dibs-react-intl';

import { BasicSelect } from 'dibs-elements/exports/BasicSelect';

import fieldNames from '../../data/sellerApplicationFieldNames.json';

import { State_geographySalesforce$key } from './__generated__/State_geographySalesforce.graphql';

type Props = {
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    errorMessage?: ReactNode;
    value: string;
    geographySalesforce: State_geographySalesforce$key | null;
    disabled?: boolean;
};

const messages = defineMessages({
    state: {
        id: 'DealerApplicationForm.state.placeholder',
        defaultMessage: 'State',
    },
});

const State: FC<Props> = ({
    onChange,
    errorMessage,
    value,
    geographySalesforce: geographySalesforceRef,
    disabled,
}) => {
    const intl = useIntl();

    const geographySalesforce = useFragment(
        graphql`
            fragment State_geographySalesforce on GeographySalesforce {
                states(countryCode: "US") {
                    name
                    abbreviation
                }
            }
        `,
        geographySalesforceRef
    );

    const statesOptions = (geographySalesforce?.states || []).map(state => ({
        value: state?.abbreviation || '',
        label: state?.name || '',
    }));

    return (
        <BasicSelect
            placeholder={intl.formatMessage(messages.state)}
            name={fieldNames.dealerInfo.state}
            dataTn="state"
            hasAnimatedPlaceholder
            options={statesOptions}
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            value={value}
            disabled={disabled}
        />
    );
};

export default State;
